import { defineStore } from "pinia";
import { useLoadingStore } from "@/stores/loadingStore";
import { getBlogs } from "@/services/contentService";

export const useHomeBlogStore = defineStore("homeBlogStore", {
  state: () => ({
    blogs: [],
    isLoading: false,
    error: null,
  }),

  actions: {
    async fetchBlogs() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await getBlogs(1, 3);
        this.blogs = response;
      } catch (error) {
        this.error = "Bloglar alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
